import React from "react";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";
import IconeCanal from "../IconeCanal";

// Avatar do contato com a marca do canal de onde ele veio.
//
// O sinal é o selo no canto, não a foto em si: Messenger e Instagram entregam foto de
// perfil de verdade, e trocá-la pelo logo do canal esconderia justamente o que o
// atendente usa para reconhecer a pessoa. O selo também não depende da AUSÊNCIA de foto
// para funcionar — regra que se desfaria sozinha no dia em que o WhatsApp oficial passar
// a entregar foto.
//
// Contato de WhatsApp não ganha selo nenhum: é a maioria esmagadora da lista, e marcar
// todo mundo é o mesmo que não marcar ninguém.

const useStyles = makeStyles(theme => ({
  wrapper: {
    position: "relative",
    display: "inline-flex",
  },
  selo: {
    position: "absolute",
    right: -2,
    bottom: -2,
    // O anel da cor do fundo separa o selo da foto — sem ele, foto escura come o ícone.
    background: theme.palette.background.paper,
    borderRadius: "50%",
    padding: 1,
    lineHeight: 0,
    boxShadow: "0 0 0 1px rgba(0,0,0,0.08)",
  },
}));

const AvatarContato = ({ contact, size = 14, ...props }) => {
  const classes = useStyles();
  const canal = contact && contact.canal;

  if (!canal) {
    return <Avatar src={contact && contact.profilePicUrl} {...props} />;
  }

  return (
    <span className={classes.wrapper}>
      <Avatar src={contact.profilePicUrl} {...props} />
      <span className={classes.selo}>
        <IconeCanal tipo={canal} size={size} />
      </span>
    </span>
  );
};

export default AvatarContato;
